import {DatePicker, Select} from "antd";
import React, {Fragment, useRef} from "react";
import {ConditionsProps} from "../../utils/segmentBuilder";
import dayjs from "dayjs";

const SegmentBuilderStep = ({ index, excludedActions, sentCampaigns, countries, productVariants, conditions, onUpdate, leaf, onSelect, isEditMode }: { index: number; excludedActions: string[]; sentCampaigns: any; countries: { label: string; value: string }[]; productVariants: any; conditions: ConditionsProps; onUpdate: (key: string, value: any) => void; leaf: any; onSelect: (key: string, value: any) => void, isEditMode: boolean }) => {
    const lineBreaker = leaf.isLineBreaker ? <div className="line-breaker" style={{ flexBasis: '100%', height: 0}} /> : null;
    const dateRangeValueRef = useRef<{ from: Date, to: Date }>({ from: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), to: new Date() });
    // @ts-ignore
    const selected = conditions[leaf.key];

    const selectedLabel = leaf.list === 'productList' ? (selected === 'any' ? 'Any products' : 'Specific product')
        : leaf.list === 'campaignList' ? (selected === 'any' ? 'Any campaigns' : 'Specific campaign')
        : leaf.list === 'countryList' ? (selected === 'any' ? 'Anywhere' : 'Specific country')
        : leaf?.options ? leaf.options.find((opt: any) => opt.key === selected)?.label : selected;

    const next = selected && (
        (leaf.options?.find((l: any) => l.key === selected)?.next) ||
        (leaf.input && selected && leaf?.next) ||
        (leaf.list && selected && leaf?.next)
    );

    const onClick = (newVal: any) => {
        onSelect(leaf.key, newVal);
        onUpdate(leaf.key, newVal);
    }

    if (leaf?.options && !leaf?.list) {
        if(leaf.options.length === 1 && !selected) {
            onClick(leaf.options[0].key);
        }
        const options = leaf.key === 'action' ? leaf.options.filter((opt: any) => !excludedActions.includes(opt.key)) : leaf.options;
        return (
            <Fragment key={leaf.nodeKey}>
                {lineBreaker}
                {leaf.label ? <div className={`row-label ${leaf.isLabelPartOfSentence ? 'sentence' : ''}`}>{leaf.label}</div> : null}
                {leaf.options.length > 1 ?
                    <Select placeholder={leaf.placeholder || "Choose an option"} value={selected} onChange={(val) => {
                        const selected = leaf.options.find((o: any) => o.key === val);
                        onClick(selected.key);
                    }} className={`new-segment-select new-segment-item-${leaf.key}`}>
                        {options.map((o: any, i: number) => (
                            <Select.Option key={o.key} value={o.key} className="new-segment-select-item">{o.label}</Select.Option>
                        ))}
                    </Select>
                : <div className="label">{options[0].label}</div>}
                {leaf.closerLabel ? <div className="label">{leaf.closerLabel}</div> : null}
                {next ? <SegmentBuilderStep index={index} excludedActions={excludedActions} sentCampaigns={sentCampaigns} countries={countries} productVariants={productVariants} conditions={conditions} onUpdate={onUpdate} leaf={next} onSelect={onSelect} isEditMode={isEditMode} /> : null}
            </Fragment>
        );
    }

    if (leaf?.input === 'date') {
        return (
            <Fragment key={leaf.nodeKey}>
                {lineBreaker}
                {leaf.label ? <div className="row-label">{leaf.label}</div> : null}
                <div className="relative flex new-segment-date-container">
                    <DatePicker value={dayjs(selected?.from) || null} onChange={(dateValue) => {
                        dateRangeValueRef.current = { from: dateValue.toDate(), to: dateRangeValueRef.current.to };
                        onClick(dateRangeValueRef.current);
                    }} className={`new-segment-input new-segment-item-${leaf.key}`} disabledDate={(current) => current && current.isAfter(dateRangeValueRef.current.to, 'day')} allowClear={false} />
                    <DatePicker value={dayjs(selected?.to) || null} onChange={(dateValue) => {
                        dateRangeValueRef.current = { from: dateRangeValueRef.current.from, to: dateValue.toDate() };
                        onClick(dateRangeValueRef.current);
                    }} className={`new-segment-input new-segment-item-${leaf.key}`} disabledDate={(current) => current && current.isBefore(dateRangeValueRef.current.from, 'day')} allowClear={false} />
                </div>
                {next ? <SegmentBuilderStep index={index} excludedActions={excludedActions} sentCampaigns={sentCampaigns} countries={countries} productVariants={productVariants} conditions={conditions} onUpdate={onUpdate} leaf={next} onSelect={onSelect} isEditMode={isEditMode} /> : null}
            </Fragment>
        );
    }

    if (leaf?.input) {
        return (
            <Fragment key={leaf.nodeKey}>
                {lineBreaker}
                {leaf.label ? <div className="row-label">{leaf.label}</div> : null}
                <div className="relative">
                    <input type={leaf.input} value={selected || ''} onChange={(event: any) => onClick(event.target.value || '')} className={`new-segment-input new-segment-item-${leaf.key}`} />
                    {leaf.closerLabel ? <div className="input-close-label">{selected === '1' || selected === 1 ? leaf.singleCloserLabel : leaf.closerLabel}</div> : null}
                </div>
                {next ? <SegmentBuilderStep index={index} excludedActions={excludedActions} sentCampaigns={sentCampaigns} countries={countries} productVariants={productVariants} conditions={conditions} onUpdate={onUpdate} leaf={next} onSelect={onSelect} isEditMode={isEditMode} /> : null}
            </Fragment>
        );
    }

    if(leaf?.list === 'productList') {
        return (
            <Fragment key={leaf.nodeKey}>
                {lineBreaker}
                {leaf.label ? <div className="row-label">{leaf.label}</div> : null}
                <Select placeholder={leaf.placeholder || "Choose an option"} value={selected} onChange={(val) => {
                    if(val === 'any' || val === 'all') {
                        onClick(val);
                    } else {
                        const selected = productVariants.find((o: any) => o.key === val);
                        onClick(selected.key);
                    }
                }} className={`new-segment-select new-segment-item-product`}>
                    {leaf.options?.map((o: any, i: number) => (
                        <Select.Option key={o.key} value={o.key} className="new-segment-select-item">{o.label}</Select.Option>
                    ))}
                    {productVariants?.map((product: any, i: number) => (
                        <Select.Option key={product.key} value={product.key} className="new-segment-select-item">
                            <div className="new-segment-product-item">
                                <img alt={product.title} src={product.src} />
                                <div className="product-details">
                                    <div className="title">{product.title}</div>
                                    {/*<div className="price">{product.currency}{product.price}</div>*/}
                                </div>
                            </div>
                        </Select.Option>
                    ))}
                </Select>
                {leaf.closerLabel ? <div className="label">{leaf.closerLabel}</div> : null}
                {next ? <SegmentBuilderStep index={index} excludedActions={excludedActions} sentCampaigns={sentCampaigns} countries={countries} productVariants={productVariants} conditions={conditions} onUpdate={onUpdate} leaf={next} onSelect={onSelect} isEditMode={isEditMode} /> : null}
            </Fragment>
        );
    }

    if(leaf?.list === 'campaignList') {
        return (
            <Fragment key={leaf.nodeKey}>
                {lineBreaker}
                {leaf.label ? <div className="row-label">{leaf.label}</div> : null}
                <Select placeholder={leaf.placeholder || "Choose an option"} value={selected} onChange={(val) => {
                    if(val === 'any' || val === 'all') {
                        onClick(val);
                    } else {
                        const selected = sentCampaigns.find((o: any) => o.id === val);
                        onClick(selected.id);
                    }
                }} className={`new-segment-select new-segment-item-product`}>
                    {leaf.options?.map((o: any, i: number) => (
                        <Select.Option key={o.key} value={o.key} className="new-segment-select-item">{o.label}</Select.Option>
                    ))}
                    {sentCampaigns?.map((campaign: any, i: number) => (
                        <Select.Option key={campaign.id} value={campaign.id} className="new-segment-select-item">
                            <div className="new-segment-campaign-item">
                                <div className="campaign-details">
                                    <div className="title">{campaign.title}</div>
                                </div>
                            </div>
                        </Select.Option>
                    ))}
                </Select>
                {leaf.closerLabel ? <div className="label">{leaf.closerLabel}</div> : null}
                {next ? <SegmentBuilderStep index={index} excludedActions={excludedActions} sentCampaigns={sentCampaigns} countries={countries} productVariants={productVariants} conditions={conditions} onUpdate={onUpdate} leaf={next} onSelect={onSelect} isEditMode={isEditMode} /> : null}
            </Fragment>
        );
    }

    if(leaf?.list === 'countryList') {
        return (
            <Fragment key={leaf.nodeKey}>
                {lineBreaker}
                {leaf.label ? <div className="row-label">{leaf.label}</div> : null}
                <Select placeholder={leaf.placeholder || "Choose a country"} value={selected} onChange={(val) => {
                    if(val === 'any' || val === 'all') {
                        onClick(val);
                    } else {
                        const selected = countries.find((o: any) => o.value === val);
                        onClick(selected?.value || null);
                    }
                }} className={`new-segment-select new-segment-item-country`}>
                    {leaf.options?.map((o: any, i: number) => (
                        <Select.Option key={`country-${o.value}`} value={o.value} className="new-segment-select-item">{o.label}</Select.Option>
                    ))}
                    {countries?.map((country: any, i: number) => (
                        <Select.Option key={`country-${country.value}`} value={country.value} className="new-segment-select-item">
                            <div className="new-segment-country-item">
                                <div className="flex country-details">
                                    <div className="country-flag-container"><img alt={country.label} className="country-flag" src={`https://flagcdn.com/w40/${country.value.toLowerCase()}.png`} /></div>
                                    <div className="title">{country.label}</div>
                                </div>
                            </div>
                        </Select.Option>
                    ))}
                </Select>
                {leaf.closerLabel ? <div className="label">{leaf.closerLabel}</div> : null}
                {next ? <SegmentBuilderStep index={index} excludedActions={excludedActions} sentCampaigns={sentCampaigns} countries={countries} productVariants={productVariants} conditions={conditions} onUpdate={onUpdate} leaf={next} onSelect={onSelect} isEditMode={isEditMode} /> : null}
            </Fragment>
        );
    }

    return null;
};

export default SegmentBuilderStep;